import axios from 'axios';
import MainLayout from "@/components/layout/MainLayout.vue";
import moment from 'moment';
import { mapGetters } from "vuex";

export default {
    name: "contentGroup",
    components: {
        MainLayout,
    },

    data() {
        return {
            classPayment: {},
            lastPage: "",
            currentPage: "",
        }
    },
    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        getPayment() {
            axios.get(`/${this.userType}/payment/` + this.$route.params.id)
                .then((response) => {
                    this.classPayment = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                });
        },
    },

    filters: {
        setMoment: function (date) {
            if (date && moment(date).isValid()) {
                return moment(date).format("DD MMMM YYYY");
              }
            return '-';
        },
        capitalize: function (data) {
            return data.charAt(0).toUpperCase() + data.slice(1);
        }
    },

    mounted() {
        this.getPayment();
    }
};
